import React from 'react';
import { CheckOutlined, ExclamationOutlined, CloseOutlined } from '@ant-design/icons';

interface IProps {
  value: 'Success' | 'Warning' | 'Failure';
  onClick?: () => void;
}

export const InspectionStatusRadio: React.FC<IProps> = ({ value, onClick }) => {
  const iconStyle = { fontSize: 25, fontWeight: 'bold' };

  const map = {
    Success: { icon: <CheckOutlined style={iconStyle} />, color: '#52c41a' },
    Warning: { icon: <ExclamationOutlined style={iconStyle} />, color: '#faad14' },
    Failure: { icon: <CloseOutlined style={iconStyle} />, color: '#ff4d4f' },
  };

  const opt = map[value];

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: opt?.color || '#d9d9d9',
        color: '#fff',
        width: 50,
        height: 35,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 12,
        fontSize: 22,
        border: `2px solid ${opt?.color || '#d9d9d9'}`,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {opt?.icon || null}
    </div>
  );
};
